import { useScreen } from "layout/ControlLayout";
import StreamingSourceButton from "components/streaming/StreamingSourceButton";
import ToggleMapButton from "components/control/ToggleMapButton";
import { useCallback, useMemo } from "react";
import { useDeviceFeatureFlags } from "providers/DeviceFeatureFlagsProvider";

const SwitchScreenButtons = () => {
    const { screen, setScreen, setShowSecondaryView } = useScreen();
    const { flags } = useDeviceFeatureFlags();
    const { HAS_MAP_VIEW } = flags;

    const isStreamSelected = screen === "stream";
    const isMapSelected = screen === "map";

    // Apply translucent grey mask to unselected buttons
    const unselectedStyle = "relative before:absolute before:inset-0 before:bg-black before:bg-opacity-40 before:pointer-events-none";

    const streamButtonOnClick = useMemo(() => {
        if (!isStreamSelected) {
            return () => {
                setScreen("stream");
                setShowSecondaryView(true);
            };
        } else {
            // return null so that <StreamingSourceButton /> calls its own onClick i.e. to select source
            return null;
        }
    }, [isStreamSelected, setScreen, setShowSecondaryView])

    return (
        <div className="flex">
            <StreamingSourceButton
                className={`${HAS_MAP_VIEW ? "rounded-r-none" : ""} ${!isStreamSelected ? unselectedStyle : ""}`}
                onClick={streamButtonOnClick}
            />
            {HAS_MAP_VIEW && (
                <ToggleMapButton
                    className={`rounded-l-none ${!isMapSelected ? unselectedStyle : ""}`}
                    onClick={() => {
                        setScreen("map");
                        setShowSecondaryView(true);
                    }}
                />
            )}
        </div>
    );
};

export default SwitchScreenButtons;
